/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// generate a globally unique id that will be used to link a product to its imprinting products
function generateGUID() {
    var d = new Date().getTime();
    var d2 = (performance && performance.now && (performance.now() * 1000)) || 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}


// handles adding item to cart with all its imprinting products
function addToCart(tags) {
    try {
        document.body.style.cursor = 'wait';
        $('.invalid').removeClass('invalid');

        const items = [];
        const unique_id = generateGUID();
        const qty = Number($('select[name="quantity"]').val());
        const variant_id = $('input[name="selected_variant"]').val();

        const product_data = {
            quantity: qty,
            id: variant_id,
        };

        items.push(product_data)

        if ($('input[name="properties[Imprinting]"]').val() == 'Add Imprinting' && tags.includes('ImprintingType')) {

            items[0].properties = {
                _guid: unique_id
            }

            //GET IMPRINTING VARIANT         
            const imprintingType = tags.split(',').find(t => t.startsWith('ImprintingType')).split(':')[1]
         
            const impVariant = ids.imprinting[imprintingType][site];


            //GET IMPRINTING LOCATION
            let impLocation = $('input[name="properties[Location]"]').val();
            if (!impLocation) {
                try {
                    impLocation = $('input[name^="properties[Location:"]').attr('name').split(':')[1].replace(']', '');
                } catch {
                    $('.location fieldset').addClass('invalid');
                    return;
                }
            }


            //GET IMPRINTING QTY
            const locCount = impLocation.split(',').length;
            const impQty = qty * locCount;


            const impProperties = {
                _guid: unique_id,
                Location: impLocation
            };


            //GET IMPRINTING COLORS
            const color_inputs = $('input[name$="Color]"]:checked');
            if (color_inputs && color_inputs.length > 0) {
                color_inputs.each((i, ci) => {
                    let name = ci['name'];
                    name = name.substring(name.indexOf('[') + 1, name.indexOf(']'))
                    impProperties[name] = ci['value'];
                })
            }

            const imprinting_data = {
                quantity: impQty,
                id: impVariant,
                properties: impProperties
            };

            items.push(imprinting_data);

            if ($('input[name="properties[Plate]"]:checked').val() == 'New Plate') {
                const file = $('input[name="properties[Upload]"]').val();
                if (file) {
                    const plate_data = {
                      
                        quantity: 1,
                        id: ids.plate[site],
                        properties: {
                            _fileUrl: file,
                            _guid: unique_id
                        }
                    };

                    items.push(plate_data);
                  
                } else {
                    //$('form[data-uploadery] .spb-fileupload').addClass('invalid');
                   // return;
                }
            } else if (cartItemsThemePage) {
              //check if product with exact same imprinting already exists in cart - if yes, take same GUID so shopify will combine them
                const sameProdWithSameImp = cartItemsThemePage.find(ci => ci.id == variant_id && ci.properties && ci.properties._guid
                    && cartItemsThemePage.find(ici => ici.id === impVariant && compareObjects(ici.properties, { ...impProperties, _guid: ci.properties._guid })))
                if (sameProdWithSameImp && !cartItemsThemePage.find(ci => ci.id === ids.plate[site] && ci.properties._guid === sameProdWithSameImp.properties._guid)) {
                   
                    items[0].properties._guid = sameProdWithSameImp.properties._guid
                    items[1].properties._guid = sameProdWithSameImp.properties._guid
                }
            }
        }

        setTimeout(function () {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', '/cart/add.js', true);
            xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhr.send(JSON.stringify({ items: items }));
            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4) {
                    console.log(xhr);
                    document.body.style.cursor = 'default';
                    if (xhr.status == 200) {
                        $(".atc-modal").removeClass("hidden");
                    }
                    else if (xhr.status == 422) {
                        $(".qty-validation").addClass("invalid");
                    }
                  setCartItems()
                }
            }
        }, 1);


    } catch(ex) { document.body.style.cursor = 'default'; console.log(ex) }
}





function compareObjects(o1, o2) {
    for (var p in o1) {
        if (!o1.hasOwnProperty(p) || o1[p] != o2[p]) {
            return false;
        }
    }
    for (var p in o2) {
        if (!o2.hasOwnProperty(p) || o1[p] != o2[p]) {
            return false;
        }
    }
    return true;
};